export default __webpack_public_path__ + "static/media/logo-tch.1f636080.svg";